import { GetServerSidePropsContext } from "next";

import Bugsnag from "@bugsnag/js";

import CollectionsPageLayout from "components/CollectionsPageLayout";
import {
  collectionsUrl as getCollectionsUrl,
  sortOptions,
} from "components/CollectionsPageLayout/CollectionsPageAll";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";

const EntityInsightsTabPage: NextPageWithLayout = () => {
  return <CollectionsPageLayout />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const collectionsUrl = getCollectionsUrl(1, {}, sortOptions[0].sortStr);

  try {
    const [collections] = await Promise.all([
      baseFetcher(collectionsUrl, context).catch(() => []),
    ]);

    return {
      props: {
        fallback: {
          [`$inf$${collectionsUrl}`]: [collections],
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps collection Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

export default EntityInsightsTabPage;
